export enum TooltipIconEnum {
  defaultVisibility = 'default_visibility',
  supervisorInvisibility = 'supervisor_invisibility',
  pivotScreenVisibility = 'pivot_screen_visibility',
}

export type ColumnsIconType = {
  kind: TooltipIconEnum;
};

export type ColumnsIconTypeApi = ColumnsIconType;

export type TableColumnEntityApi = {
  /** идентификатор колонки */
  id: string;

  /** Флаг ( сортируем ли колонку или нет) -  на 'pivot' sortable всегда false */
  sortable: boolean;

  /** Текстовое название колонки */
  name: string;

  /** Отображается ли колонка по умолчанию */
  default_visibility: boolean;

  /** Иконки тултипов */
  icons: ColumnsIconTypeApi[];
};

export type TableColumnEntity = {
  id: string;

  sortable: boolean;

  name: string;

  visible: boolean;

  icons: ColumnsIconType[];
};
